
import React, { useState } from 'react';
import { WaitlistPopup } from '@/components/WaitlistPopup';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

type WaitlistWidgetProps = {
  variant?: 'default' | 'hero' | 'inline';
  buttonText?: string;
  className?: string;
};

export const WaitlistWidget = ({ 
  variant = 'default',
  buttonText = 'Get Early Access', // Updated default text
  className = '',
}: WaitlistWidgetProps) => {
  const [showWaitlist, setShowWaitlist] = useState(false);

  const openWaitlist = () => {
    setShowWaitlist(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape' && showWaitlist) {
      setShowWaitlist(false);
    }
  };

  const renderButton = () => {
    // Use the vibrant blue color like in the images
    const buttonClasses = "rounded-full px-6 py-3 text-white font-medium bg-[#2432ff] hover:bg-[#1c29e8] transition-colors duration-300 shadow-lg";
    
    return (
      <Button 
        className={`${buttonClasses} ${className}`}
        asChild
      >
        <Link to="/early-access">{buttonText}</Link>
      </Button>
    );
  };

  return (
    <div onKeyDown={handleKeyDown}>
      {renderButton()}
      {showWaitlist && <WaitlistPopup onClose={() => setShowWaitlist(false)} />}
    </div>
  );
};
